<template lang="pug">
g-data-table.confirmationTable(
  :items="pagination.data",
  :options.sync="options",
  :server-items-length="pagination.total",
  show-select,
  v-model="selected",
  v-bind="{ headers, loading }"
)
  //- v-show="!loading"
  template(v-slot:item.Orderline_Additional_Information.ShipByDate="{ item, header }")
    .item-extra(:class="{ ['orange--text']: isHighlight($getExtraFieldValue(item, header)) }") {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Orderline_Additional_Information.SpecialProject="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Orderline_Additional_Information.Mot="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Orderline_Additional_Information.INCOTERM="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.dateDeliveryFrom="{ item }") {{ item.dateDeliveryFrom }}
  template(v-slot:top)
    v-row.table__title
      v-col.h2.primary--text {{ $t('PendingAsn.pendingAsn') }}
    v-row.table__top
      v-col.py-0
        app-entity-search(
          :criteria="[]",
          @pagination="pagination = $event",
          :loads="loads",
          :entity="entity",
          :rowsPerPage="options.itemsPerPage || null",
          :wheres="asnWheres"
        )
      v-col.pt-4(cols="auto")
        g-btn.h8(
          color="primary",
          @click="createShipment",
          :disabled="!selected.length",
        ) {{ $t('PendingAsn.createShipment') }}
</template>

<style lang="scss" scoped>
.g-data-table .row.table__top {
  flex-grow: 0;
}
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';

export default {
  name: 'AsnTable',
  data () {
    return {
      loading: true,
      asnWheres: [],
      tableWheres: [],
      options: {},
      selected: [],
      // Added wheres here for initial pagination
      // sent also to entity search
      pagination: {},
      // Same loads as endpoint call on load()
      loads: ['CollectionPoint', 'DeliveryPoint', 'Product', 'Status', 'Responsibilities.Task', 'ExtraData', 'Order'],
    }
  },
  watch: {
    options: {
      handler(options) {
        this.load(options);
      }
    },
    selected: {
      handler() {
          this.load()
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('PendingAsn.polNumber'), value: "externalId" },
        { text: this.$t('PendingAsn.readyToShipDate'), value: "datePickupFrom", type:'DateTime'  },
        { text: this.$t('PendingAsn.shipFromCountry'), value: "collectionPoint.countryName" },
        { text: this.$t('PendingAsn.shipByDate'), value: "Orderline_Additional_Information.ShipByDate", type:'DateTime' },
        { text: this.$t('PendingAsn.deliveryDate'), value: "dateDeliveryFrom", type:'DateTime' },
        { text: this.$t('PendingAsn.urgencyLevel'), value: "urgencyLevel" },
        { text: this.$t('PendingAsn.specialProject'), value: "Orderline_Additional_Information.SpecialProject" },
        { text: this.$t('PendingAsn.mot'), value: "Orderline_Additional_Information.Mot" },
        { text: this.$t('PendingAsn.incoterm'), value: "Orderline_Additional_Information.INCOTERM" },
        { text: this.$t('PendingAsn.requestedQuantity'), value: "requestedQuantity" },
        { text: this.$t('PendingAsn.availableQuantity'), value: "availableQuantity" }
      ]
    },
    wheres() {
      var w = ['x => x.Responsibilities.Any(r => r.State == "Open" && r.Task.Type == "ASN")']
      //w.push('x => x.Responsibilities.Any(r => r.Status == 2 and r.Task.Type == "CONF")');
      w.push('x => !x.ExtraData.Any(e => e.Key == "Orderline_Additional_Information.COL_DETAILS_ONHOLD" && e.Bool == true)');
      w.push('x => x.RequestedQuantity.HasValue && x.RequestedQuantity > 0');
      w.push('x => x.AvailableQuantity.HasValue && x.AvailableQuantity > 0');
      w.push('x => x.Status.Name == "CONFIRMED" || x.Status.Name == "ASN Start"');
      //Add all filters when an OrderLine is selected
      if (this.selected.length > 0) {
        w.push('x => x.DeliveryPointId == ' + this.selected[0].deliveryPointId)
        var MOT = this.selected[0].extraData.find(e => e.extraField != null && e.extraField.name === 'Mot')
        var Inc = this.selected[0].extraData.find(e => e.extraField != null && e.extraField.name === 'INCOTERM')
        MOT && w.push('x => x.ExtraData.Any(e => e.ExtraFieldId == '+ MOT.extraFieldId +' and e.String == "' + MOT.value + '")')
        Inc && w.push('x => x.ExtraData.Any(e => e.ExtraFieldId == '+ Inc.extraFieldId +' and e.String == "' + Inc.value + '")')
        if(this.selected[0].datePickupFrom){
          var todayAdd60 = new Date(this.selected[0].datePickupFrom);
          todayAdd60.setDate(todayAdd60.getDate() + 60);
          var todaySubtract60 = new Date(this.selected[0].datePickupFrom);
          todaySubtract60.setDate(todaySubtract60.getDate() - 60);
          w.push('x => x.DatePickupFrom < ' +  '\"' + todayAdd60.toISOString() + '\" && x.DatePickupFrom > ' +  '\"' + todaySubtract60.toISOString() + '\"')
        }
      }
      this.asnWheres = w
      return w
    },
    entity() {
      return this.$findEntity('OrderLine');
    },
  },
  methods: {
    isHighlight(date) {
      let dateMoment = moment(date);
      if (!date || !dateMoment.isValid()) return false;
      // Highlight is any date 5 days or less before today
      let highlight = moment.utc().add(6, 'days');
      return highlight.isAfter(dateMoment, 'day');
    },
    createShipment() {
      this.$store.commit('setAsnOrderLines', this.selected)
      this.$router.push({ name: 'shipment.add', params: {Asn:true} })
    },
    setPagination(event) {
      //For ASN table, always have the same pagination.where
      event.where = this.pagination.where
      this.pagination = event;
    },
    getPagination(options = null, where = null) {
      options = options || this.options;
      if (!_.keys(options).length) return;
      // console.log('OPTS ', options)
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: "dateDeliveryFrom",
          desc: false,
          where: where,
        }
      };
    },
    async load(options = null) {
      if (this.selected.length < 2) {
        this.loading = true
        this.pagination.data = []
        this.tableWheres = this.pagination.where ? this.pagination.where.filter(x => !this.asnWheres.includes(x)) : [];
        try {
          this.loading = true;
          const pagination = this.getPagination(options, this.tableWheres.concat(this.wheres));
          let endpoint = this.$fetchLoad(
            "OrderLine",
            true,
            "Product",
            'CollectionPoint', 'DeliveryPoint', 'Product', 'Status', 'Responsibilities.Task', 'ExtraData', 'Order'
          );
          this.pagination = (await axios.get(endpoint, pagination)).data;
          // Uncomment the following lines if u want the filter to be made on the Front
          // if (this.selected.length > 0) {
          //   this.pagination.data = this.pagination.data.filter(ol => ol.Mot === this.selected[0].Mot && ol.Incoterm === this.selected[0].Incoterm)
          // }
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false
        }
      }
      this.loading = false
    }
  }
}
</script>
